import React from 'react';
import { object } from 'prop-types';
import css from './SeoDiscovery.module.css';

const formatReviewDate = value => {
  if (!value) {
    return null;
  }
  const parsed = new Date(`${value}T12:00:00`);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }
  return parsed.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

const SeoEditorialTrust = props => {
  const { trust } = props;
  if (!trust) {
    return null;
  }

  const { lastReviewed, sources, editorialNote, methodology, officialWebsite } = trust;
  const reviewedLabel = formatReviewDate(lastReviewed);

  if (!reviewedLabel && !(sources || []).length && !editorialNote) {
    return null;
  }

  return (
    <aside className={css.trustPanel} aria-label="Editorial trust and sources">
      {reviewedLabel ? (
        <p className={css.trustMeta}>
          <span className={css.trustLabel}>Last reviewed:</span> {reviewedLabel}
        </p>
      ) : null}
      {editorialNote ? <p className={css.trustNote}>{editorialNote}</p> : null}
      {methodology ? <p className={css.trustMethodology}>{methodology}</p> : null}
      {sources?.length ? (
        <div className={css.trustSources}>
          <p className={css.trustLabel}>Sources used</p>
          <ul className={css.trustSourceList}>
            {sources.map(source => (
              <li key={`${source.id}-${source.url || source.label}`}>
                {source.url ? (
                  <a href={source.url} rel="noopener noreferrer">
                    {source.label}
                  </a>
                ) : (
                  source.label
                )}
              </li>
            ))}
            {officialWebsite &&
            !sources.some(source => source.url === officialWebsite || source.id === 'official-website') ? (
              <li>
                <a href={officialWebsite} rel="noopener noreferrer">
                  Official venue website
                </a>
              </li>
            ) : null}
          </ul>
        </div>
      ) : null}
    </aside>
  );
};

SeoEditorialTrust.propTypes = {
  trust: object,
};

export default SeoEditorialTrust;
